export const PAGE_SIZE_OPTIONS = [25, 50, 100]
export const DEFAULT_PAGE_SIZE = 25
export const MAX_PAGE_SIZE = 100000
export const FALLBACK_VALUE = '-'
export const DG_RESELLER_ID = 'DG'
export const MODEM_4G_PRODUCT_LINK =
  'https://www.dinamicagenerale.com/product/modem-4g/'
export const ALLOWED_LICENSES_IDS = [
  'dtm8_ic',
  'dtm8_pro',
  'dtm8_pro_contractor',
]
export const LICENSE_VERSION_LABELS: Record<string, string> = {
  dtm8_ic: 'DTM8 IC',
  dtm8_pro: 'DTM8 Advanced',
  dtm8_pro_contractor: 'DTM8 Contractor',
} as const
